import { pubsub } from '@services';
import { fetchHTML } from '@utils';

class CollectionGrid extends HTMLElement {
  abortController;

  connectedCallback() {
    this.unsubscribeSortChanged = pubsub.subscribe('sort:changed', () => this.handleSortChange());
    this.unsubscribeFiltersUpdated = pubsub.subscribe('filters:updated', () =>
      this.handleSortChange(),
    );

    this.stickyBar = this.querySelector('[data-sticky-bar]');
    this.stickyBarPlaceholder = this.querySelector('[data-placeholder]');
    this.filterBarSpace = this.querySelector('[data-bar-wrapper]');

    if (this.stickyBar && this.stickyBarPlaceholder && this.filterBarSpace) {
      this.observer?.disconnect();
      const amountStickyBottom = window.getComputedStyle(this.stickyBar).bottom || '0px';
      this.stickyBottom = parseFloat(amountStickyBottom) || 0;
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
        threshold: 1,
        rootMargin: `0px 0px -${amountStickyBottom} 0px`,
      });
      this.observer.observe(this.filterBarSpace);
    }
  }

  disconnectedCallback() {
    this.unsubscribeSortChanged();
    this.unsubscribeFiltersUpdated();
    this.observer?.disconnect();
  }

  /**
   * Handle sort change
   */
  async handleSortChange() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const searchParams = new URLSearchParams(window.location.search);

    try {
      const html = await fetchHTML(
        `${window.location.pathname}?section_id=main-collection&${searchParams}`,
      );

      this.renderProductGrid(html);
    }
    catch (error) {
      console.error(error);
    }
  }

  /**
   * Render product grid
   * @param {HTMLElement} html - HTML to render
   */
  renderProductGrid(html) {
    const parsedCollectionGrid = html.querySelector('collection-grid');

    this.innerHTML = parsedCollectionGrid.innerHTML;
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      // isIntersecting with threshold 1 is unreliable with fractional pixels (zoom, display scaling)
      // and is also false when the bar space has scrolled out above the viewport.
      // Only fix the bar while its space is below the visible area (1px tolerance for rounding).
      const isBelowViewport
        = entry.boundingClientRect.bottom > window.innerHeight - this.stickyBottom + 1;

      if (!isBelowViewport) {
        this.stickyBar.classList.remove('fixed');
        this.stickyBarPlaceholder.classList.add('hidden');
      }
      else {
        this.stickyBar.classList.add('fixed');
        this.stickyBarPlaceholder.classList.remove('hidden');
      }
    });
  }
}

customElements.define('collection-grid', CollectionGrid);
